import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  position: relative;
  top: 60px;
  z-index: 1;
`;

const Background = ({ themeColor }: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2060.9 1283.2">
    <defs>
      <clipPath id="p">
        <path d="M432.24 494.8h-96.207l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="c"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 383.64 494.81)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="m">
        <path d="M432.24 418.21h-96.207l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="b"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 383.64 418.21)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="l">
        <path d="M432.24 343.66h-96.207l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="a"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 383.64 343.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="z">
        <path d="M432.24 267.3h-96.207l-6 107.21h107.21z" />
      </clipPath>
      <linearGradient
        id="k"
        x2="1"
        gradientTransform="matrix(0 107.21 107.21 0 383.64 267.3)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#a0a0a0" />
        <stop offset="0.23" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" />
      </linearGradient>
      <clipPath id="y">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="x">
        <path d="M324.19 770.8l104.46-23.808h737.7c50.44 0 91.329-44.2 91.329-98.723v-332.74l79.857-64.082 2.339 348.3c0 94.476-70.851 171.06-158.25 171.06z" />
      </clipPath>
      <linearGradient
        id="j"
        x2="1"
        gradientTransform="scale(833.8 -833.8) rotate(72.591 1.181 .109)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#1b75bb" />
        <stop offset="0.287" stopColor="#1b75bb" />
        <stop offset="0.945" stopColor="#8dbadd" />
        <stop offset="1" stopColor="#8dbadd" />
      </linearGradient>
      <clipPath id="w">
        <path d="M512.11 465.08h425.78v239.5H512.11z" />
      </clipPath>
      <linearGradient
        id="i"
        x2="1"
        gradientTransform="scale(426.64 -426.64) rotate(33.014 3.392 1.408)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.036" stopColor="#282827" />
        <stop offset="0.154" stopColor="#797979" />
        <stop offset="0.165" stopColor="#797979" />
        <stop offset="0.291" stopColor="#c7c7c7" />
        <stop offset="0.412" stopColor="#797979" />
        <stop offset="0.552" stopColor="#282827" />
        <stop offset="0.634" stopColor="#282827" />
        <stop offset="0.754" stopColor="#282827" />
        <stop offset="0.863" stopColor="#b3b3b4" />
        <stop offset="0.972" stopColor="#646565" />
        <stop offset="1" stopColor="#646565" />
      </linearGradient>
      <clipPath id="v">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="u">
        <path d="M1398.1 637.34h211.91v7.696H1398.1z" />
      </clipPath>
      <linearGradient
        id="h"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1398.1 641.18)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="t">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="s">
        <path d="M1398.1 200.38h211.91v7.697H1398.1z" />
      </clipPath>
      <linearGradient
        id="g"
        x2="1"
        gradientTransform="matrix(211.91 0 0 -211.91 1398.1 204.23)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#282827" />
        <stop offset="0.427" stopColor="#c7c7c7" />
        <stop offset="0.546" stopColor="#c7c7c7" />
        <stop offset="0.937" stopColor="#515050" />
        <stop offset="1" stopColor="#515050" />
      </linearGradient>
      <clipPath id="r">
        <path d="M0 1265.6h1907.7V0H0z" />
      </clipPath>
      <clipPath id="q">
        <path d="M1022.2 431.1c-43.316 0-79.539-14.21-104.07-87.319l-.708-87.32h331.68v94.169c-14.505 41.84-56.91 80.47-100.22 80.47z" />
      </clipPath>
      <linearGradient
        id="f"
        x2="1"
        gradientTransform="matrix(0 174.64 174.64 0 1083.3 256.46)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#323232" />
        <stop offset="0.029" stopColor="#323232" />
        <stop offset="0.177" stopColor="#323232" />
        <stop offset="0.661" stopColor="#646464" />
        <stop offset="1" stopColor="#1e1e1e" />
      </linearGradient>
      <clipPath id="o">
        <path d="M994.88 405.34c-43.314 0-78.427-35.113-78.427-78.427v-119h336.22v119c0 43.314-35.113 78.427-78.427 78.427z" />
      </clipPath>
      <linearGradient
        id="e"
        x2="1"
        gradientTransform="matrix(0 197.42 197.42 0 1084.6 207.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#323232" />
        <stop offset="0.029" stopColor="#323232" />
        <stop offset="0.177" stopColor="#323232" />
        <stop offset="0.661" stopColor="#646464" />
        <stop offset="1" stopColor="#1e1e1e" />
      </linearGradient>
      <clipPath id="n">
        <path d="M998.32 386.57c-36.777 0-66.59-29.814-66.59-66.59V207.91h304.26v112.07c0 36.776-29.813 66.59-66.59 66.59z" />
      </clipPath>
      <linearGradient
        id="d"
        x2="1"
        gradientTransform="matrix(0 178.66 178.66 0 1083.9 207.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#1b75bb" />
        <stop offset="0.287" stopColor="#1b75bb" />
        <stop offset="0.945" stopColor="#8dbadd" />
        <stop offset="1" stopColor="#8dbadd" />
      </linearGradient>
    </defs>
    <path
      fill="#e6e7e8"
      d="M0 0h-1545.7l262.14 178.34h1011.5z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5) translate(1705.5 170.4)"
    />
    <path
      fill={themeColor || '#52a4d1'}
      d="M159.81 152.5h1545.7v18.057H159.81z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    />
    <path
      fill="#404041"
      d="M0 0h-171.96l16 410.55H-14z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5) translate(469.91 207.16)"
    />
    <path
      fill="#bbbdbf"
      d="M0 0h-120.96l-10 410.55H11z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5) translate(444.91 207.16)"
    />
    <g
      clipPath="url(#p)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="url(#c)" d="M432.24 494.8h-96.207l-6 107.21h107.21z" />
    </g>
    <g
      clipPath="url(#m)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="url(#b)"
        d="M432.24 418.21h-96.207l-6 107.21h107.21z"
      />
    </g>
    <g
      clipPath="url(#l)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="url(#a)"
        d="M432.24 343.66h-96.207l-6 107.21h107.21z"
      />
    </g>
    <g
      clipPath="url(#z)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="url(#k)" d="M432.24 267.3h-96.207l-6 107.21h107.21z" />
    </g>
    <path
      fill="#404041"
      d="M486.28 199.37H281v15.575h205.28z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    />
    <path
      fill="#6b6b6b"
      d="M867.15 316.84H588.98v686.81h278.17z"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    />
    <g
      clipPath="url(#y)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="none"
        stroke={themeColor || '#52a4d1'}
        strokeMiterlimit="10"
        strokeWidth="35"
        d="M0 0v352.17C0 454.1-76.438 535.72-170.73 534.72h-859.78"
        transform="translate(1354.7 251.44)"
      />
    </g>
    <g
      clipPath="url(#x)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill={themeColor || 'url(#j)'}
        d="M324.19 770.8l104.46-23.808h737.7c50.44 0 91.329-44.2 91.329-98.723v-332.74l79.857-64.082 2.339 348.3c0 94.476-70.851 171.06-158.25 171.06z"
      />
    </g>
    <g
      clipPath="url(#w)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="url(#i)" d="M512.11 465.08h425.78v239.5H512.11z" />
    </g>
    <g
      clipPath="url(#v)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="none"
        stroke="#59595c"
        strokeMiterlimit="10"
        strokeWidth="7"
        d="M937.89 465.08H512.11v239.5h425.78z"
      />
      <path fill="#d0d2d3" d="M1604 207.34h-200v430h200z" />
    </g>
    <g
      clipPath="url(#u)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="url(#h)" d="M1398.1 637.34h211.91v7.696H1398.1z" />
    </g>
    <g
      clipPath="url(#t)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="#282827" d="M1398.4 633.64h-3.83v15.096h3.83z" />
      <path fill="#515050" d="M1613.8 633.64h-3.83v15.096h3.83z" />
    </g>
    <g
      clipPath="url(#s)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="url(#g)" d="M1398.1 200.38h211.91v7.697H1398.1z" />
    </g>
    <g
      clipPath="url(#r)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path fill="#282827" d="M1398.4 196.68h-3.83v15.095h3.83z" />
      <path fill="#515050" d="M1613.8 196.68h-3.83v15.095h3.83z" />
      <path
        fill="#e6e7e8"
        stroke="#bbbdbf"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1045.4 877.32H417.17v235.59h628.23z"
      />
    </g>
    <g
      clipPath="url(#q)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="url(#f)"
        d="M1022.2 431.1c-43.316 0-79.539-14.21-104.07-87.319l-.708-87.32h331.68v94.169c-14.505 41.84-56.91 80.47-100.22 80.47z"
      />
    </g>
    <g
      clipPath="url(#o)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill="url(#e)"
        d="M994.88 405.34c-43.314 0-78.427-35.113-78.427-78.427v-119h336.22v119c0 43.314-35.113 78.427-78.427 78.427z"
      />
    </g>
    <g
      clipPath="url(#n)"
      transform="matrix(1.3333 0 0 -1.3333 -213.08 1486.5)"
    >
      <path
        fill={themeColor || 'url(#d)'}
        d="M998.32 386.57c-36.777 0-66.59-29.814-66.59-66.59V207.91h304.26v112.07c0 36.776-29.813 66.59-66.59 66.59z"
      />
    </g>
  </svg>
);

export interface BoothBackgroundProps {
  themeColor?: string;
}

const BoothBackground: React.FC<BoothBackgroundProps> = ({ themeColor }: BoothBackgroundProps) => (
  <RootContainer>
    <BackgroundContainer>
      <Background themeColor={themeColor} />
    </BackgroundContainer>
  </RootContainer>
);

export default BoothBackground;
